import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';

export const BulkActionMenu = ({ id, isLoading, selectionModel, actions }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isMenuOpen = Boolean(anchorEl);

  return (
    <>
      <Button
        id={`${id}__button_actions`}
        variant="contained"
        className="myOdu__button primary"
        onClick={handleOpen}
        aria-controls={isMenuOpen ? `${id}__menu` : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        disabled={isLoading}
      >
        <Typography id={`${id}__text_label_actions`} variant="small" pr={1}>
          Actions
        </Typography>
        <FontAwesomeIcon icon={faCaretDown} />
      </Button>
      <Menu
        id={`${id}__menu`}
        aria-labelledby={`${id}__button_actions`}
        open={isMenuOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{ top: -70, left: 20, zIndex: 1400 }}
      >
        {actions.length &&
          actions.map((action, index) => (
            <MenuItem
              id={`${id}__menuItem_${index}`}
              key={index}
              onClick={() => {
                action.handler(Object.values(selectionModel));
                handleClose();
              }}
              disabled={action.disabled}
            >
              {action.title}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};
